import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  changeField,
  pushElement,
  initializeForm,
  select,
  ans_check,
} from "../modules/problem";
import { check, setDomainNames } from "../modules/auth";
import { achievement } from "../modules/result";
import ProblemViewForm from "../components/ProblemViewForm";

const ProblemViewContainer = ({ history }) => {
  const dispatch = useDispatch();
  const [src, setSrc] = useState("");
  const [clickLock, setClickLock] = useState(false);
  const [waiting, setWaiting] = useState(false);
  const [progress, setProgress] = useState(0);
  const [areaView, setAreaView] = useState(0);
  const [seqNo, setSeqNo] = useState(0);
  const [status, setStatus] = useState({
    "status-motion": "is-standby",
    "status-text": <span>답안 제출 대기 중···</span>,
  });
  const {
    problem_info,
    select_problem,
    solved_problems,
    solved_domains,
    loading,
    next,
    achieve,
    auth,
    authError,
    domainNames,
  } = useSelector(({ problem, loading, result, auth }) => ({
    problem_info: problem.problem_info,
    select_problem: problem.select,
    solved_problems: problem.solved_problems,
    solved_domains: problem.solved_domains,
    loading: loading,
    next: problem.next,
    achieve: result.achievement,
    auth: auth.auth,
    authError: auth.authError,
    domainNames: auth.domainNames,
  }));

  /*
   * 토큰 유효성 검증
   */
  useEffect(() => {
    console.log("1번째");
    dispatch(check());
  }, [dispatch]);

  /*
   * 토큰이 유효하다면(auth 객체가 있다면) 문제 정보(problem_info), 푼 문제 목록(solved_problems), 푼 영역 정보(solved_domains)를 초기화한다.
   * select()로 푼 문제 목록과 푼 영역 정보, 현재 문제 출제 순서를 파라미터로 보내 다음 문제를 응답받는다.
   * domainNmaes(영역의 명칭)은 초등 / 중등, 학년 별로 다르므로 이후 사용될 도메인 영역 명칭을 위해 미리 설정해놓는다.(setDomainNames() 메소드 사용)
   *
   * waiting state를 통해 문제 제출 혹은 문제 로딩 중 문제 풀이를 방지한다.
   * 정답 제출 버튼은 항상 리액트 프론트의 ProblemViewForm에 존재하지만
   * 문제는 불러오기전까지 존재하지 않으므로 문제를 불러올때까지 정답 제출 버튼을 누를 수 없게 만들어야한다.
   */
  useEffect(() => {
    console.log("2번째");
    if (authError) {
      return;
    } else if (auth) {
      setWaiting(true);
      dispatch(initializeForm("problem_info"));
      dispatch(initializeForm("solved_problems"));
      dispatch(initializeForm("solved_domains"));
      dispatch(
        select({
          solved_problems: solved_problems,
          solved_domains: solved_domains,
          seq_no: 0,
        })
      );

      let domainNames = [];
      const grade = parseInt(auth.grade);
      const st_month = parseInt(auth.st_month);
      if (grade >= 7) {
        domainNames = [
          ["수와 연산", "수와 연산"],
          ["문자와 식", "측정"],
          ["함수", "규칙성"],
          ["기하", "도형"],
          ["확률과 통계", "자료와 가능성"],
        ];
        if (grade === 7 && st_month <= 5) {
          domainNames[1] = ["측정", "측정"];
        }
      } else {
        domainNames = [
          ["수와 연산", "수와 연산"],
          ["도형", "도형"],
          ["측정", "측정"],
          ["규칙성", "규칙성"],
          ["자료와 가능성", "자료와 가능성"],
        ];
      }
      dispatch(setDomainNames(domainNames));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth, authError, dispatch]);

  /*
   * select() 메소드가 유효하다면 select_problem 객체와 최신 상태의 solved_domains를 응답한다.
   * select_problem 객체는 다음 문제에 대한 정보와 진단평가 종료 여부를 담고 있음
   * if 진단평가가 종료되었다면
   *  setAreaView(1)를 통해 문제보기 페이지의 정답 제출버튼을 progress 바로 바꾸고
   *  프로그레스 바의 로딩이 끝났다면 setAreaView(2)를 통해 결과확인 버튼으로 변경함.
   *  areaView state의 0, 1, 2 값은 ProblemViewForm에서 각각 정답 제출, 프로그레스 바, 결과확인 버튼으로 변환됨
   * elif 진단평가가 종료되지 않았으면:
   *  API에서 전달받은 solved_domains와 클라이언트의 solved_domains를 동기화해서 최신 상태로 유지하고
   *  select_problem 객체에 담긴 problem_id로 iframe을 새로고침함
   */
  useEffect(() => {
    console.log("3번째");
    if (loading["problem/SELECT"] === false) {
      if (select_problem) {
        if (select_problem.is_done) {
          setAreaView(1);
          setStatus({
            "status-motion": "is-analyzing",
            "status-text": <span>제출 답안 기반 이해도 분석 중···</span>,
          });
          setTimeout(setProgress, 1000, 100);
          setTimeout(() => {
            setStatus({
              "status-motion": "is-end",
              "status-text": (
                <span>
                  분석 완료, 진단 평가를 종료합니다.
                  <br />
                  결과 리포트를 확인해주세요!
                </span>
              ),
            });
            setAreaView(2);
            /*alert("종료!");
            history.push("/diagnosis/result/");
            return;*/
          }, 3500);
        } else {
          dispatch(
            changeField({
              form: "solved_domains",
              key: "domain_cds",
              value: select_problem.solved_domains.domain_cds,
            })
          );
          for (
            let i = 0;
            i < select_problem.solved_domains.domain_cds.length;
            i++
          ) {
            let domain_cd = select_problem.solved_domains.domain_cds[i];
            let select_solved_domains = select_problem.solved_domains;
            dispatch(
              changeField({
                form: "solved_domains",
                key: domain_cd,
                value: select_solved_domains[domain_cd],
              })
            );
          }
          setSrc(
            `${process.env.REACT_APP_API_SERVER}/diagnosis/api/problem_view/${select_problem.seq_no}/${select_problem.problem_id}`
          );
        }
      }
    }
  }, [dispatch, loading, select_problem, history]);

  /*
   * 만약 ProblemViewForm에서 정답확인 버튼을 눌렀다면
   * ans_check() 메소드를 호출해 정오답 여부를 응답받고
   * 푼 문제 수에 따라 AI 모션을 다르게 출력
   * clickLock state는 정답 제출 과정 중 문제와 상호작용하는 행위를 방지함.
   *
   * 정답 확인 버튼을 통해 ans_check() 메소드를 호출하고 정오답 여부(is_right)를 응답받았다면
   * 이미 문제를 풀었다는 의미이므로 푼 문제 목록(solved_problems)에 문제 정보(problem_info)를 추가함.
   */
  useEffect(() => {
    console.log("4번째");
    if (problem_info.is_right !== null) {
      if (solved_problems.length >= 2) {
        setStatus({
          "status-motion": "is-prepare-2",
          "status-text": (
            <span>
              이해도 분석 완료. <br />
              다음 문항 준비 중···
            </span>
          ),
        });
      } else
        setStatus({
          "status-motion": "is-prepare-1",
          "status-text": (
            <span>
              좀 더 정확한 이해도 분석을 위해 <br /> 다음 문항 준비 중···
            </span>
          ),
        });
      setTimeout(() => {
        setClickLock(false);
        dispatch(pushElement(problem_info));
      }, 2000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, problem_info]);

  /*
   * sovled_problems에 problem_info를 push_element() 메소드를 통해 추가했다면 next state가 생성됨
   * next가 있다면 이미 문제를 풀었다는 의미이므로
   * 푼 문제 목록(solved_problems)과 직전 영역별 이해도(achieve)를 파라미터로 achievement() 메소드를 호출한다.
   * acheivement() 메소드는 최신 상태의 영역별 이해도(achieve)를 응답한다.
   *
   * 문제를 이미 풀었으므로 다음 문제를 select() 메소드를 호출해 가져온다.
   * 문제를 이미 풀었으므로 현재 문제 정보를 담은 problem_info state를 초기화한다.
   */
  useEffect(() => {
    console.log("5번째");
    if (next !== null) {
      dispatch(
        achievement({ solved_problems: solved_problems, achieve: achieve })
      );
      dispatch(
        select({
          solved_problems: solved_problems,
          solved_domains: solved_domains,
          seq_no: select_problem.seq_no,
        })
      );
      dispatch(initializeForm("problem_info"));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, next]);

  /*
   * iframe의 child window로부터 값을 전달받을 때마다
   * 전달받은 값을 problem_info 객체에 입력한다.
   * 만약 문제를 불러온 직후라면(ansinput === null) AI 모션을 답안 제출 대기중으로 바꾸고 문제 출제 순서(seqNo)도 +1 한다.
   * 문제를 불러오고 난 후이므로 waiting state는 false로 한다.
   */
  const onChange = (e) => {
    const { value, name } = e;
    dispatch(
      changeField({
        form: "problem_info",
        key: name,
        value,
      })
    );
    if (name === "ansinput" && value === "null") {
      setStatus({
        "status-motion": "is-standby",
        "status-text": <span>답안 제출 대기 중···</span>,
      });
      setSeqNo(seqNo + 1);
    }
    setWaiting(false);
  };

  /*
   * onClick 메소드는 정답 제출 버튼을 클릭하는 이벤트를 다룬다.
   * 만약 waiting state가 true라면 아직 문제를 불러오기 전이라는 의미이므로 버튼 클릭을 방지한다.
   * 버튼을 클릭했다면 clickLock state를 true로 바꾸고, clickLock state는 문제와의 상호작용을 방지한다.
   * problem_info의 problem_id와 사용자 입력 ansinput을 파라미터로 ans_check() 메소드를 호출해 정오답 여부(is_right)를 응답받는다.
   * 푼 문제 수에 따라 AI 모션을 다르게 표현한다.
   */
  const onClick = (e) => {
    if (!waiting) {
      e.preventDefault();
      setClickLock(true);
      const { problem_id, ansinput } = problem_info;
      if (ansinput === "null") {
        setStatus({
          "status-motion": "is-analyzing",
          "status-text": <span>답안을 분석 중···</span>,
        });
        setClickLock(false);
      }
      else {
        if (solved_problems.length >= 2)
          setStatus({
            "status-motion": "is-analyzing",
            "status-text": <span>제출 답안 기반 이해도 분석 중···</span>,
          });
        else
          setStatus({
            "status-motion": "is-analyzing",
            "status-text": <span>답안 제출 대기 중···</span>,
          });
        setWaiting(true);
        setTimeout(() => {
          dispatch(ans_check({ problem_id, ansinput }));
        }, 2000);
      }
    }
  };

  /*
   * areaView가 2가 되면(결과 확인 버튼으로 바뀌면)
   * 결과 확인 버튼을 클릭하는 이벤트를 onFinishClick 메소드가 다룬다.
   * result page를 호출하기 위해 대기하는 상태인 loading page로 이동한다.
   */
  const onFinishClick = (e) => {
    e.preventDefault();
    history.push("/diagnosis/loading/");
  };

  /*
   * iframe이 렌더링될 때마다 onLoad 메소드가 발생한다.
   * ifrmae 내부의 child window에서 데이터를 보내는 메소드와 통신하기위해 EventListner를 매 iframe마다 추가해준다.
   * child window가 보내는 데이터들을 전달받아 위에서 만든 onChagne 메소드를 통해 problem_info 객체의 값을 바꾼다.
   */
  const onLoad = () => {
    window.addEventListener("message", (e) => {
      if (e.origin === process.env.REACT_APP_API_SERVER) {
        let problem_info = e.data;
        for (let key in problem_info) {
          onChange({ name: key, value: problem_info[key] });
        }
      }
    });
  };

  return (
    <>
      {auth ? (
        <ProblemViewForm
          src={src}
          clickLock={clickLock}
          onLoad={onLoad}
          onClick={onClick}
          onFinishClick={onFinishClick}
          status={status}
          progress={progress}
          areaView={areaView}
          achieve={achieve}
          seqNo={seqNo}
          grade={auth.grade}
          domainNames={domainNames}
          name={auth.name}
          t_type={auth.t_type}
        ></ProblemViewForm>
      ) : (
        <p>no</p>
      )}
    </>
  );
};

export default withRouter(ProblemViewContainer);
